import { render, staticRenderFns } from "./PatientMedicalRecordImages.vue?vue&type=template&id=95337550&scoped=true&"
import script from "./PatientMedicalRecordImages.vue?vue&type=script&lang=js&"
export * from "./PatientMedicalRecordImages.vue?vue&type=script&lang=js&"
import style0 from "./PatientMedicalRecordImages.vue?vue&type=style&index=0&id=95337550&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95337550",
  null
  
)

export default component.exports